// Text constants for ListsNull component
const NullViewTexts = {
  cardTitle: ['Save Your Favorites.', 'Use Again and Again.'],
  benefits: [
    'Store collections of your go‑to materials.',
    'Quickly copy items from your Lists to a Project, Quote, or Shopping Cart.',
  ],
  imageAlt: 'Placeholder image',
  cta: 'Create List',
  learnMoreText: 'Learn More',
  // imageUrl: 'https://dam.thdstatic.com/content/production/nlPKlSIZxxlMYYBB5rujfg/2DcEm3xMy_0doFmVCQnSrQ/'
  // + 'Contentful%20Hero%2016:10/2023_ProCustom_Handyman_Cabinet_Install_0707_v3_Contentful%20Hero%201610.jpg',
  imageUrl: 'https://dam.thdstatic.com/content/production/nlPKlSIZxxlMYYBB5rujfg/2DcEm3xMy_0doFmVCQnSrQ/'
  + 'Contentful%20Hero%2016:10/2023_ProCustom_Handyman_Cabinet_Install_0707_v3_Contentful%20Hero%201610.jpg'
};

export default NullViewTexts;
